import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(3),
    },
    label: {
        marginBottom: theme.spacing(1),
        fontWeight: 500,
        fontSize: '1.1rem',
    },
    textField: {
        '& .MuiInputBase-input.Mui-disabled': {
            color: theme.palette.text.primary,
            '-webkit-text-fill-color': theme.palette.text.primary,
            fontSize: '1.6rem',
        },
    },
}));

const EmailEditor = () => {
    const classes = useStyles();
    const email = useSelector(state => state.user.currentUser.email);

    return (
        <Box className={classes.root}>
            <Typography className={classes.label}>
                メールアドレス
            </Typography>
            <TextField
                fullWidth
                variant="outlined"
                value={email}
                disabled
                className={classes.textField}
                InputProps={{
                    readOnly: true,
                }}
            />
        </Box>
    );
};

export default EmailEditor;